import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  CARD_TYPES,
  CARD_MASKS,
  defineCardType,
  defineCardMask
} from "../../utils/credit-card-validators";
import { ReactComponent as CreditCardIcon } from "../../styles/default/assets/icons/ic-credit-card-default.svg";

const CreditCard = ({
  components,
  name,
  title,
  isRequired,
  params,
  fieldAttributes,
  placeholder,
  onUpdateValue,
  onEnterDown,
  isInvalid,
  appData,
  srLabel
}) => {
  const { Label, TextField, CreditCardLogo } = components;
  const [cardType, setCardType] = useState(
    fieldAttributes?.defaultValue
      ? defineCardType(fieldAttributes.defaultValue)
      : CARD_TYPES.not_defined
  );
  const [mask, setMask] = useState(
    appData.isPulse ? CARD_MASKS.by4 : CARD_MASKS.default
  );
  const handleInputChange = event => {
    const cardNumber = event.target.value.replace(/[^0-9]/g, "");
    onUpdateValue(event);
    setCardType(defineCardType(cardNumber));
    setMask(defineCardMask(cardNumber));
  };

  return (
    <div className='credit-card-wrapper-web-sdk'>
      <Label
        name={name}
        text={title}
        isRequired={isRequired}
        params={params}
        invalid={isInvalid}
        appData={appData}
        srLabel={srLabel}
      >
        {appData.isPulse && (
          <CreditCardIcon className='credit_card_icon_pulse' />
        )}
        <TextField
          name={name}
          fieldAttributes={fieldAttributes}
          maskingAttributes={{ maskChar: " ", mask }}
          placeholder={placeholder}
          updateValue={handleInputChange}
          onEnterDown={onEnterDown}
          onChangeValue={handleInputChange}
          invalid={isInvalid}
        />
      </Label>
      <CreditCardLogo type={cardType} />
    </div>
  );
};

CreditCard.propTypes = {
  components: PropTypes.objectOf(PropTypes.func).isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  params: PropTypes.string.isRequired,
  fieldAttributes: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onUpdateValue: PropTypes.func.isRequired,
  onEnterDown: PropTypes.func.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  appData: PropTypes.objectOf(PropTypes.object),
  srLabel: PropTypes.string
};

export default CreditCard;
